import { useQuery, gql } from '@zenbusiness/application-commons-graphql';
import jsonSoftParse from '@zenbusiness/application-commons-utils/jsonSoftParse';
import Alert from '@zenbusiness/zui/Alert';
import AlertTitle from '@zenbusiness/zui/AlertTitle';
import LinearProgress from '@zenbusiness/zui/LinearProgress';
import Paper from '@zenbusiness/zui/Paper';
import PropTypes from 'prop-types';


export default function Hello({ name, sx }) {
  const {
    loading,
    error,
    data: { hello } = {}
  } = useQuery(
    gql`
      query Hello($name: String!) {
        hello(name: $name)
      }
    `,
    {
      noThrow: true,
      variables: {
        name
      }
    }
  );

  if (!name) {
    return null;
  }

  if (loading) {
    return (
      <Paper
        elevation={3}
        sx={sx}
      >
        <div>&nbsp;</div>
        <LinearProgress />
      </Paper>
    );
  }

  if (error) {
    const { fetchError, graphQLErrors, httpError } = error;

    if (fetchError) {
      throw fetchError;
    }
    if (graphQLErrors) {
      throw graphQLErrors[0];
    }
    if (httpError) {
      return (
        <Alert
          elevation={1}
          severity="error"
          sx={sx}
        >
          <AlertTitle>{`Server Error (${httpError.status} ${httpError.statusText}):`}</AlertTitle>
          {jsonSoftParse(httpError.body)?.errors?.map?.(({ message }) => message)}
        </Alert>
      );
    }
  }

  return (
    hello && (
      <Paper
        elevation={3}
        sx={{ ...sx, p: 2 }}
      >
        {hello}
      </Paper>
    )
  );
}

Hello.propTypes = {
  name: PropTypes.string,
  sx: PropTypes.shape({})
};
